import React, { useState, useEffect } from "react";
import USAMapBox from "./UsaMap";
import WorldMapBox from "./WorldMap";
import StateCitymap from "./StateCitymap";
import "../../assets/css/mapbox.css";
import MapIcon from "../../assets/img/map-icon.svg";
import MapIconBLue from "../../assets/img/map-icon-blue.svg";
import WorldIcon from "../../assets/img/public-icon.svg";
import WorldIconblue from "../../assets/img/public-icon-blue.svg";
import { Container } from "reactstrap";
import { Store } from "StoreContext";
import BrandSelector from "../../components/BrandSelector/BrandSelector";
import api from "api";
import { useLocation } from "react-router-dom";

const MapBox = () => {
  const [mapType, setMapType] = useState("usa");
  const [stateName, setStateName] = useState("");
  const [fullstateName, setFullStateName] = useState("");
  const [selectedBrandId, setSelectedBrandId] = useState("");
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [orders, setOrders] = useState([]);
  const { user } = Store();

  useEffect(() => {
    if (selectedBrandId) {
      api("get", `/orders?brandId=${selectedBrandId}&pageSize=100`).then(res => {
        setOrders(res?.orders || []);
      });
    } else {
      setOrders([]);
    }
    setSelectedOrderId("");
    setSelectedBatchId("");
  }, [selectedBrandId]);

  // Auto-set brandId for brand users so Order/Batch dropdowns appear
  useEffect(() => {
    if (user?.role === 'brand' && user?._id) {
      setSelectedBrandId(user._id);
    }
  }, [user]);

  // Read URL params to pre-select order/batch from Map links
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlOrderId = params.get('orderId');
    const urlBatchId = params.get('batchId');
    if (urlOrderId && orders.length > 0) {
      setSelectedOrderId(urlOrderId);
      if (urlBatchId) {
        setSelectedBatchId(urlBatchId);
      }
    }
  }, [location.search, orders]);

  const handleMapChange = (type) => {
    setMapType(type);
  };

  return (

    <Container fluid style={{
      fontFamily: "outfit",
      gap: '20px',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {/* Header + Filters */}
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
        <h1 className="vs-page-title" style={{ margin: 0, flexShrink: 0 }}>Activity Map</h1>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "10px" }}>
          {user?.role === "admin" && (
            <BrandSelector
              selectedBrandId={selectedBrandId}
              onBrandChange={setSelectedBrandId}
            />
          )}
          {selectedBrandId && orders.length > 0 && (
            <select
              value={selectedOrderId}
              onChange={e => { setSelectedOrderId(e.target.value); setSelectedBatchId(""); }}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #E4E4E4",
                fontFamily: "Outfit",
                fontSize: "14px",
                color: "#1c1c1c",
                backgroundColor: "#ffffff",
                cursor: "pointer",
                minWidth: "220px",
                maxWidth: "360px",
              }}
            >
              <option value="">All Orders</option>
              {orders.map(order => {
                const date = order.createdAt ? new Date(order.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: '2-digit' }) : '';
                const batchCount = order.batchIds?.length || 0;
                const label = order.description || order.brandId?.name || 'Order';
                return (
                  <option key={order._id} value={order._id}>
                    {label} · {batchCount} batch{batchCount !== 1 ? 'es' : ''} · {date}
                  </option>
                );
              })}
            </select>
          )}
          {selectedOrderId && (
            <select
              value={selectedBatchId}
              onChange={e => setSelectedBatchId(e.target.value)}
              style={{
                padding: "8px 12px",
                borderRadius: "6px",
                border: "1px solid #E4E4E4",
                fontFamily: "Outfit",
                fontSize: "14px",
                color: "#1c1c1c",
                backgroundColor: "#ffffff",
                cursor: "pointer",
                minWidth: "220px",
                maxWidth: "360px",
              }}
            >
              <option value="">All Batches</option>
              {orders.find(o => o._id === selectedOrderId)?.batchIds?.map(batch => {
                const date = batch.createdAt ? new Date(batch.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: '2-digit' }) : '';
                const codes = batch.number_of_codes ? `${batch.number_of_codes.toLocaleString()} codes` : '';
                return (
                  <option key={batch._id} value={batch._id}>
                    {batch.product_name || 'Batch'} · {codes} · {date}
                  </option>
                );
              })}
            </select>
          )}
          <div className="d-flex bg-white"
            style={{
              borderRadius: "6px"
            }}
          >
            <button
              className={`px-4 ${mapType === "usa" ? "active" : "inactive"}`}
              onClick={() => handleMapChange("usa")}
              style={{
                backgroundColor: mapType === "usa" ? "#362FD8" : "#ffffff",
                border: "none",
                borderRadius: '6px',
                color: mapType === "usa" ? "#FFFFFF" : "#1c1c1c",
              }}
            >
              USA
            </button>
            <button
              className={`px-4 py-2 ${mapType === "world" ? "active" : "inactive"
                }`}
              onClick={() => handleMapChange("world")}
              style={{
                backgroundColor: mapType === "world" ? "#362FD8" : "#ffffff",
                color: mapType === "world" ? "#FFFFFF" : "#1c1c1c",
                border: "none",
                borderRadius: '6px',
              }}
            >
              World
            </button>
          </div>
        </div>
      </div>

      {/* Conditionally render USA or World map based on mapType */}
      {mapType === "usa" ? (
        <USAMapBox setMapType={setMapType} setStateName={setStateName} setFullStateName={setFullStateName} brandId={selectedBrandId} orderId={selectedOrderId} batchId={selectedBatchId} />
      ) : mapType === "world" ? (
        <WorldMapBox brandId={selectedBrandId} orderId={selectedOrderId} batchId={selectedBatchId} />
      ) : mapType === "state" ? (
        <StateCitymap stateName={stateName} fullstateName={fullstateName} brandId={selectedBrandId} orderId={selectedOrderId} batchId={selectedBatchId} />
      ) : null}

    </Container>
  );
};

export default MapBox;
